import { render, staticRenderFns } from "./MovimientoProducto.vue?vue&type=template&id=01eb36bc&"
import script from "./MovimientoProducto.vue?vue&type=script&lang=js&"
export * from "./MovimientoProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports